import { Observable } from 'rxjs';
import { AgregarEntregaChequeRequiestDTO, AgregarEntregaChequeResponseDTO,
    ComprobanteRequiestDTO, ComprobanteResponseDTO } from 'src/app/data/dto/EntregaChequesDTO';
export abstract class EntregaChequesRepository {
    abstract agregarEntregaCheque(request: AgregarEntregaChequeRequiestDTO): Observable<AgregarEntregaChequeResponseDTO>;
    abstract agregarComprobante(request: ComprobanteRequiestDTO): Observable<ComprobanteResponseDTO>;
}
